import { z } from "zod";
import {
  FLASH_1,
  FLASH_2,
  NEWS_1,
  NEWS_2,
} from "./consts";

export const approvalSchema = z.object({
  [FLASH_1]: z
    .any()
    .optional()
    .refine((val) => {
      if (!val) return true;
      if (val?.length > 10 && val?.length < 500) {
        return true;
      }
      return false;
    }, "Text must be between 10 and 500 characters"),
  [FLASH_2]: z
    .any()
    .optional()
    .refine((val) => {
      if (!val) return true;
      if (val?.length > 10 && val?.length < 500) {
        return true;
      }
      return false;
    }, "Text must be between 10 and 500 characters"),
  [NEWS_1]: z.any().optional(),
  [NEWS_2]: z.any().optional(),
});

export type approvalFormValues = z.infer<typeof approvalSchema>;